module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAUVBMVEUAAADrPz7rQjzqQD/qPz/qQD///k7qQj/98U3ua0LuZkL0okbvckP+/E75zUr2skjsVUDrTT/860z74Ev61Er3vUjzmkbyj0XxhkTtXUHsWUEKHYkwAAAABXRSTlMA8CaureAuZHYAAADBSURBVEjH7dW5DoMwEEVRTPAbb2D27f8/NJYCCKUgMxUpuJWRfCTsYpw9scoLpZmpIk/7lRak8uylRb0yJQMq08LuA0RCEIIQxCgDZAyJQACCCEQgSgAZwBAH1M45a+2E1JQW6bO+BhW+qq6BJl/iVOnp5xlCi6M2cA7dVMfvNMxbMp/9hnutDluOCfwOPBN0gJlnA3Q8sAD9qvXaAwsLjNvlky9HFhjsvrIDCzSn5T9NjRuBeBiLx734QRE/WU+c3s0rJGuw09lnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flag/vi@2x.png
// module id = uSB8
// module chunks = 0